// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__17d_b","choiceBoxes":"toolbarselects_choiceBoxes__2-neN","simpleField":"toolbarselects_simpleField__2Rq79"};